import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {KTCard} from '../../../_metronic/helpers'
import VendorRisk from './VendorRisk'
import {VendorPageTitle} from '../../../_metronic/layout/core/VendorPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Vendor Risk Management',
    path: '/vendor-risk',
    isSeparator: true,
    isActive: false,
  },
]

const VendorRiskWrapper: FC = () => {
  return (
    <>
      <VendorPageTitle
        icon='VendorIcon.svg'
        title='Vendor Risk Management'
        desc={
          'Monitor risks associated with third party services to enhance your security posture. '
        }
        breadcrumbs={usersBreadcrumbs}
      />
      <KTCard>
        <VendorRisk className='card-xl-stretch mb-xl-8' />
      </KTCard>
    </>
  )
}

export default VendorRiskWrapper
